import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'jhi-item-count-records',
  templateUrl: './item-count.component.html',
  styleUrls: []
})
export class ItemCountComponent implements OnInit {
/**
     *  current page number.
     */
    @Input() page: number;

    /**
     *  Total number of items.
     */
    @Input() total: number;

    /**
     *  Number of items per page.
     */
    @Input() itemsPerPage: number;

      /**
     *  Response of of records.
     */
    @Input() recordsCount: number;
  constructor() { }

  ngOnInit() {
  }

}
